"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _styles = require("../../styles");

var _i18n = require("../i18n");

var _core = require("@material-ui/core");

var _validation = require("./validation");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  var _theme$palette, _theme$palette$enterp, _theme$palette2, _theme$palette2$enter, _theme$palette3, _theme$palette3$enter, _theme$palette4, _theme$palette4$enter, _theme$palette5, _theme$palette5$enter, _theme$palette6, _theme$palette6$enter, _theme$palette7, _theme$palette7$enter;

  return {
    legalDisclaimerLink: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$enterp = _theme$palette.enterprise) === null || _theme$palette$enterp === void 0 ? void 0 : _theme$palette$enterp.primary,
      fontSize: theme.spacing(1.5),
      fontWeight: 'bold' // TODO: Need to import the correct weight for pixel perfect match on designs

    },
    button: {
      backgroundColor: theme.palette.grey[400],
      '&:hover': {
        backgroundColor: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$enter = _theme$palette2.enterprise) === null || _theme$palette2$enter === void 0 ? void 0 : _theme$palette2$enter.main,
        color: theme.palette.primary.contrastText
      },
      fontSize: theme.spacing(1.75)
    },
    outlinedButton: {
      color: theme.palette.grey[600],
      outline: theme.palette.grey[600],
      border: theme.palette.grey[600],
      '&:hover': {
        color: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$enter = _theme$palette3.enterprise) === null || _theme$palette3$enter === void 0 ? void 0 : _theme$palette3$enter.main,
        outline: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : (_theme$palette4$enter = _theme$palette4.enterprise) === null || _theme$palette4$enter === void 0 ? void 0 : _theme$palette4$enter.main,
        border: (_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 ? void 0 : (_theme$palette5$enter = _theme$palette5.enterprise) === null || _theme$palette5$enter === void 0 ? void 0 : _theme$palette5$enter.main
      },
      fontSize: theme.spacing(1.75),
      '& span': {
        fontWeight: 'bold'
      }
    },
    label: {
      '&$focused': {
        color: (_theme$palette6 = theme.palette) === null || _theme$palette6 === void 0 ? void 0 : (_theme$palette6$enter = _theme$palette6.enterprise) === null || _theme$palette6$enter === void 0 ? void 0 : _theme$palette6$enter.main
      }
    },
    focused: {},
    outlinedInput: {
      '&$focused $notchedOutline': {
        border: "1px solid ".concat((_theme$palette7 = theme.palette) === null || _theme$palette7 === void 0 ? void 0 : (_theme$palette7$enter = _theme$palette7.enterprise) === null || _theme$palette7$enter === void 0 ? void 0 : _theme$palette7$enter.main)
      }
    },
    notchedOutline: {},
    alternateDestinations: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.text.secondary
    },
    divider: {
      width: '100%'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _styles.makeStyles)(styles);

var SupportModal = function SupportModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      links = _ref.links;
  var classes = useStyles();
  var enterpriseOutlineOverrideProps = {
    InputLabelProps: {
      classes: {
        root: classes.label,
        focused: classes.focused
      }
    },
    InputProps: {
      classes: {
        root: classes.outlinedInput,
        focused: classes.focused,
        notchedOutline: classes.notchedOutline
      }
    }
  };

  var onClose = function onClose() {
    setIsOpen(false);
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      uploading = _useState2[0],
      setUploading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      fileData = _useState4[0],
      setFileData = _useState4[1];

  return /*#__PURE__*/_react["default"].createElement(_.Dialog, {
    open: isOpen,
    onClose: onClose,
    hideDialogActions: true,
    disableEscapeKeyDown: true
  }, /*#__PURE__*/_react["default"].createElement(_.Spacing, {
    margin: 3
  }, /*#__PURE__*/_react["default"].createElement(_.Form, {
    initialValues: {},
    onSubmit: function onSubmit(values) {
      console.log('TODO: Implement support form mutation w/ image support', {
        values: values
      });
    },
    validationSchema: _validation.supportModalValidationSchema
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true,
    item: true,
    className: classes.fieldsContainer,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12,
    align: "left"
  }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
    variant: "h6",
    Component: "h1"
  }, _i18n.ENTERPRISE_AGENT_FLOW.SUPPORT_MODAL.HEADER)), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
    dataQa: "request-type",
    type: "text",
    label: "Request Type",
    name: "requestType",
    className: classes.enterpriseInputField
  }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
    dataQa: "first-name",
    type: "text",
    label: "First Name",
    name: "firstName",
    className: classes.enterpriseInputField
  }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
    dataQa: "last-name",
    type: "text",
    label: "Last Name",
    name: "lastName",
    className: classes.enterpriseInputField
  }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Email, (0, _extends2["default"])({
    dataQa: "work-email",
    type: "text",
    label: "Work Email",
    name: "email",
    className: classes.enterpriseInputField
  }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
    dataQa: "business-impact",
    type: "text",
    label: "Business Impact",
    name: "businessImpact",
    className: classes.enterpriseInputField
  }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
    dataQa: "message",
    type: "text",
    label: "Please Enter Your Message",
    name: "message",
    className: classes.enterpriseInputField
  }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.FileUpload, {
    required: true,
    label: "File",
    name: "file-field",
    dataQa: "file-upload",
    fileData: fileData,
    uploading: uploading,
    onChange: function onChange(event) {
      console.log({
        event: event
      });
      alert('TODO: Implement File Upload');
    },
    helperText: 'Please select a file',
    inputProps: {
      accept: '.jpeg,.png'
    }
  }))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true,
    xs: 12,
    align: "left"
  }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
    variant: "caption"
  }, _i18n.ENTERPRISE_AGENT_FLOW.SUPPORT_CAVEAT, /*#__PURE__*/_react["default"].createElement(_.Link, {
    dataQa: "consent-link",
    href: links.trustPage,
    className: classes.legalDisclaimerLink,
    target: "_blank"
  }, _i18n.ENTERPRISE_AGENT_FLOW.E_SIGN_CONSENT), ', ', /*#__PURE__*/_react["default"].createElement(_.Link, {
    dataQa: "terms-link",
    href: links.termsOfService,
    className: classes.legalDisclaimerLink,
    target: "_blank"
  }, _i18n.ENTERPRISE_AGENT_FLOW.TERMS_AND_CONDITIONS), ', and ', /*#__PURE__*/_react["default"].createElement(_.Link, {
    dataQa: "privacy-link",
    href: links.privacyPolicy,
    className: classes.legalDisclaimerLink,
    target: "_blank"
  }, _i18n.ENTERPRISE_AGENT_FLOW.PRIVACY_POLICY), '.')))))), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_.Button, {
    className: classes.outlinedButton,
    dataQa: "close",
    onClick: onClose,
    variant: "outlined"
  }, _i18n.ENTERPRISE_AGENT_FLOW.SUPPORT_MODAL.CLOSE_BUTTON), /*#__PURE__*/_react["default"].createElement(_.Button, {
    className: classes.button,
    dataQa: "close",
    onClick: onClose
  }, _i18n.ENTERPRISE_AGENT_FLOW.SUPPORT_MODAL.SUBMIT_BUTTON)));
};

SupportModal.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  setIsOpen: _propTypes["default"].func.isRequired,
  links: _propTypes["default"].object.isRequired
};
var _default = SupportModal;
exports["default"] = _default;